export const MIN_PASSWORD_LENGTH = 14;
export const ALLOWED_PASSWORD_CHARS = /^[A-Za-zÁÐÉÍÓÚÝÞÆÖáðéíóúýþæö0-9!#_,.]+$/;
